module.exports = __webpack_public_path__ + "static/media/svg-4.715313cd.svg";